(function() {
  const slidersArray = document.querySelectorAll('.customSlider');

  slidersArray.forEach(slider => {
    let prevButton = slider.querySelector('.customSlider__prevButton'),
        nextButton = slider.querySelector('.customSlider__nextButton'),
        slideWidth = slider.querySelector('.customSlider__item').clientWidth,
        sliderWidth = slider.querySelector('.customSlider__wrapper').scrollWidth,
        progressBar = slider.nextElementSibling,
        sliderWrapper = slider.querySelector('.customSlider__wrapper'),
        sliderGap = parseInt(getComputedStyle(slider.querySelector('.customSlider__item')).marginRight),
        sliderPagination = slider.querySelector('.customSlider__pagination'),
        slidersArray = slider.querySelectorAll('.customSlider__item'),
        slidesPositionArray = [];

    if (sliderPagination) {
      for (let i = 0; i < slidersArray.length; i++) {
        slidesPositionArray.push((100 / slidersArray.length * i));
      }
    }

    if (progressBar) {
      let firstBarValue = sliderWrapper.scrollLeft;

      changeProgressBar(sliderWrapper, progressBar, slideWidth, sliderGap);

      sliderWrapper.addEventListener('scroll', () => {
        changeProgressBar(sliderWrapper, progressBar, slideWidth, sliderGap);

        const pcnt = sliderWrapper.scrollLeft / sliderWidth;

        if (sliderPagination) {
          const closestIndex = 1 + slidesPositionArray.indexOf(slidesPositionArray.reduce(function(prev, curr) {
            return (Math.abs(curr - pcnt * 100) < Math.abs(prev - pcnt * 100) ? curr : prev);
          }));

          const currentPagination = slider.querySelector(`.customSlider__paginationItem:nth-child(${closestIndex})`),
                activePagination = slider.querySelector('.customSlider__paginationItem.customSlider__paginationItem--active');

          activePagination.classList.remove('customSlider__paginationItem--active');
          currentPagination.classList.add('customSlider__paginationItem--active');
        }

        if (prevButton) {
          if (firstBarValue == sliderWrapper.scrollLeft) {
            prevButton.classList.add('customSlider__nextButton--disabled');
          } else if (prevButton.classList.contains('customSlider__nextButton--disabled')) {
            prevButton.classList.remove('customSlider__nextButton--disabled');
          }
        }

        if (nextButton) {
          if (sliderWrapper.scrollLeft >= sliderWrapper.scrollWidth - sliderWrapper.clientWidth) {
            nextButton.classList.add('customSlider__nextButton--disabled');
          } else if (nextButton.classList.contains('customSlider__nextButton--disabled')) {
            nextButton.classList.remove('customSlider__nextButton--disabled');
          }
        }
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        let sliderWrapper = slider.querySelector('.customSlider__wrapper'),
            scrollPosition = sliderWrapper.scrollLeft - slideWidth;

        toggleSlider(sliderWrapper, scrollPosition);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        let sliderWrapper = slider.querySelector('.customSlider__wrapper'),
            scrollPosition = sliderWrapper.scrollLeft + slideWidth;

        toggleSlider(sliderWrapper, scrollPosition);
      });
    }

    if (sliderPagination) {
      sliderPagination.addEventListener('click', e => {
        const target = e.target;

        if (!target.matches('.customSlider__paginationItem')) {
          return;
        }

        const index = Array.from(sliderPagination.children).indexOf(target);
              paginationIndex = `.customSlider__paginationItem:nth-child(${index + 1})`,
              selector = `.customSlider__item:nth-child(${index + 1})`,
              box = document.querySelector(selector),
              paginationCurrentItem = document.querySelector(paginationIndex),
              activePagination = slider.querySelector('.customSlider__paginationItem.customSlider__paginationItem--active');

        activePagination.classList.remove('customSlider__paginationItem--active');
        paginationCurrentItem.classList.add('customSlider__paginationItem--active');

        box.scrollIntoView({
          behavior: 'smooth',
        });
      });
    }
  });

  function toggleSlider(sliderContainer, scrollPosition) {
    sliderContainer.scrollTo({
      left: scrollPosition,
    });
  }

  function changeProgressBar(slider, progressBar, slideWidth, sliderGap) {
    let calc = ((slider.scrollLeft + slideWidth) / (slider.scrollWidth - slider.clientWidth + slideWidth - sliderGap)) * 100;

    progressBar.style.backgroundSize = `${calc}% 100%`;
  }
})();
